import { useSelector } from 'umi';
import type { TUserInfo } from '@/types/common/index';

export default function useGetUserInfo(): TUserInfo {
  return useSelector<{ userInfo: TUserInfo }, TUserInfo>((state: any) => {
    return state.userInfo;
  });
}
